<template>
  <div 
  v-show="visible"
  id="g-recaptcha"
  class="g-recaptcha"
  :data-sitekey="sitekey">
  </div>
</template>

<script>
export default {
  data () {
    return {
      sitekey: '6LddSvIhAAAAAPC9LgZs9i2P_F_62xsVz4qgjNzW',
      visible: null,
      widgetId: 0
    }
  },
  methods: {
    reset () {
      this.visible = false
      window.grecaptcha.reset(this.widgetId)
    },
    render () {
      this.visible = true
      this.widgetId = window.grecaptcha.render('g-recaptcha', {
      sitekey: this.sitekey,
      size: 'normal',
      // the callback executed when the user solve the recaptcha
      callback: (response) => {
        // emit an event called verify with the response as payload
        this.$emit('verify', response)
        // reset the recaptcha widget so you can execute it again
        this.reset()
      }
      })
    }
  },
  mounted () {
    setTimeout(() => {
      const recaptchaPlugin = document.createElement("script");
      recaptchaPlugin.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=explicit");
      recaptchaPlugin.async = true;
      recaptchaPlugin.defer = true;
      document.head.appendChild(recaptchaPlugin);
    }, 3000)
	}
}
</script>